module.exports = __webpack_public_path__ + "static/media/pic3.3c3c4211.jpg";